import { useParams } from "react-router-dom";
import FormEmpresa from "./formEmpresa";

export function EmpresaIncluir() {
  const idempresa = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormEmpresa idempresa={idempresa.id} acao="Novo" />
      </div>
    </>
  );
}
